import { useEffect } from "react";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "@/hooks/useAuth";
import { ThemeProvider } from "@/components/ThemeProvider";
import { TutorialProvider } from "@/hooks/useTutorial";
import { useSessionMonitor } from "@/hooks/useSessionMonitor";
import { useMetaPixel } from "@/hooks/useMetaPixel";
import { APP_VERSION, BUILD_TIME } from "@/config/version";
import Index from "./pages/Index";
import Auth from "./pages/Auth";
import NotFound from "./pages/NotFound";
import Ayuda from "./pages/Ayuda";
import Historial from "./pages/Historial";
import { Moved, RetiredBanner } from "@/components/Retired";

const queryClient = new QueryClient();

const AppContent = () => {
  useSessionMonitor();
  useMetaPixel();
  
  return (
    <>
    <RetiredBanner />
    <Routes>
      <Route path="/" element={<Navigate to="/buscar" replace />} />
      <Route path="/buscar" element={<Index />} />
      {/* Common aliases people (and old links) land on */}
      <Route path="/index" element={<Navigate to="/buscar" replace />} />
      <Route path="/search" element={<Navigate to="/buscar" replace />} />
      <Route path="/subscription" element={<Navigate to="/suscripcion" replace />} />
      <Route path="/plans" element={<Navigate to="/planes" replace />} />
      <Route path="/help" element={<Navigate to="/ayuda" replace />} />

      <Route path="/planes" element={<Moved path="/planes" />} />
      <Route path="/suscripcion" element={<Moved path="/suscripcion" />} />
      <Route path="/auth" element={<Auth />} />
      <Route path="/ayuda" element={<Ayuda />} />
      <Route path="/historial" element={<Historial />} />
      <Route path="/admin" element={<Moved path="/admin" />} />
      {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
      <Route path="*" element={<NotFound />} />
    </Routes>
    </>
  );
};

const App = () => {
  useEffect(() => {
    console.log(`DoctIA Version: ${APP_VERSION} - Built: ${BUILD_TIME}`);
  }, []);

  return (
  <QueryClientProvider client={queryClient}>
    <HelmetProvider>
      <ThemeProvider defaultTheme="light" storageKey="doctia-theme">
        <AuthProvider>
          <TutorialProvider>
            <TooltipProvider>
              <Toaster />
              <Sonner />
              <BrowserRouter>
                <AppContent />
              </BrowserRouter>
            </TooltipProvider>
          </TutorialProvider>
        </AuthProvider>
      </ThemeProvider>
    </HelmetProvider>
  </QueryClientProvider>
  );
};

export default App;